<template>
  <span class="logo-mark" aria-hidden="true">t</span>
</template>

<style scoped lang="scss">
// The compact "t." brand mark for spots too small for the full wordmark (chat avatars, loading
// states). Sized by the parent's font-size; the period is a pseudo-element so template
// formatting can never slip whitespace between the letters.
.logo-mark {
  font-weight: 800;
  letter-spacing: -0.3px;
  color: var(--t-color-neutral-950);
  line-height: 1;

  &::after {
    content: '.';
    color: var(--t-color-orange-500);
  }
}
</style>
